var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEagleIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 215.587 207.851",
    enableBackground: "new 0 0 215.587 207.851",
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M191.227,42.434c0,0,3.153-41.061-66.871-42.417C75.303-0.9,6.672,35.798,0.183,119.203l0,0 C0.11,120.89,0,124.593,0,126.279c0,57.999,33.582,69.144,33.582,69.144s-11.768-18.954-3.336-39.191 c0,0-5.389,51.656,51.913,51.619c0,0-15.471-10.375-17.084-26.69c0,0,37.578,40.694,84.725,7.516c0,0-73.286,2.42-88.428-54.296 c0,0,8.029,10.742,22.877,21.484c17.927,12.942,45.79,25.883,81.609,20.017c0,0-31.126-12.025-29.293-46.817 c1.833-34.792,37.798-42.527,37.798-42.527c-10.595-12.392-26.176-19.431-42.491-19.137c-0.733-0.037-1.503-0.037-2.236-0.037 c2.31-0.147,4.619-0.22,6.929-0.257h1.32c0,0,65.881-7.699,58.768,16.644c0,0,13.785-1.063,18.001-10.339 C218.906,64.175,208.201,49.583,191.227,42.434z M135.721,39.355c-5.096-0.917-8.322-8.542-11.438-13.968 c-2.42-4.253-1.466-6.452,3.849-6.452c2.126,0,4.986,0.367,8.579,1.063c12.612,2.493,33.069,23.023,33.069,23.023 S139.094,39.978,135.721,39.355z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEagleIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/eagleIcon.b5c87ad31b2ce266953d816159763737.svg";